import { faCircleInfo } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip } from 'components/UI/V3/Tooltip/Tooltip';
import MobileBottomModal from 'components/UI/V3/MobileBottomModal';
import { FunctionComponent, useState } from 'react';
import { createPortal } from 'react-dom';
import { useMediaQuery } from 'react-responsive';
import styles from './InfoTooltip.module.scss';

interface InfoTooltipProps {
    content: string;
    ariaLabel: string;
}

export const InfoTooltip: FunctionComponent<InfoTooltipProps> = ({ content, ariaLabel }) => {
    const isMobile = useMediaQuery({ query: '(max-width: 959px)' });
    const [open, setOpen] = useState(false);

    const icon = (
        <FontAwesomeIcon
            icon={faCircleInfo}
            className={styles.infoIcon}
            aria-label={ariaLabel}
        />
    );

    if (!isMobile) {
        return (
            <Tooltip
                content={content}
                placement="top"
            >
                {icon}
            </Tooltip>
        );
    }

    return (
        <>
            <button
                type="button"
                className={styles.trigger}
                onClick={() => setOpen(true)}
                aria-label={ariaLabel}
            >
                {icon}
            </button>
            {open &&
                createPortal(
                    <MobileBottomModal
                        className={styles.sheet}
                        onClickAway={() => setOpen(false)}
                    >
                        <p className={styles.text}>{content}</p>
                    </MobileBottomModal>,
                    document.body
                )}
        </>
    );
};

export default InfoTooltip;
